import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

const BaseFlexColumnStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const MediaTestimonialStyles = styled.div`
  ${BaseFlexColumnStyles}
  row-gap: 2rem;
`

export const MediaTestimonialHeader = styled.div`
  ${BaseFlexColumnStyles}
  ${CONFIG.media.lg} {
    row-gap: 0.5rem;
    .media-testimonial__subheading {
      width: 48rem;
    }
  }

  text-align: center;
  row-gap: 0;
`
export const MediaTestimonialBody = styled.div`
  ${CONFIG.media.lg} {
    padding: 0 2.875rem;
  }
`
